import { render } from "./userFooter.vue?vue&type=template&id=debc07a8&ts=true"
import script from "./userFooter.vue?vue&type=script&lang=ts"
export * from "./userFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__